module.exports = __webpack_public_path__ + "static/media/telephone.ef15499b.svg";